import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState } from 'react';
/** Keeps Tab inside a dialog. */
function trapTab(event, container) {
    if (event.key !== 'Tab' || !container)
        return;
    const focusable = [
        ...container.querySelectorAll('button:not([disabled]), input, select'),
    ];
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
    }
    else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
    }
}
export function FollowUpDialog({ persons, defaultDate, normalize, onConfirm, onCancel, labels, }) {
    const [name, setName] = useState('');
    const [date, setDate] = useState(defaultDate);
    const panelRef = useRef(null);
    const personRef = useRef(null);
    const titleId = useId();
    const listId = useId();
    const hintId = useId();
    useEffect(() => personRef.current?.focus(), []);
    const trimmed = name.trim();
    const match = persons.find((person) => normalize(person.name) === normalize(trimmed));
    const canConfirm = trimmed !== '' && date !== '';
    const submit = (event) => {
        event.preventDefault();
        if (!canConfirm)
            return;
        onConfirm({ person: match ? { id: match.id, name: match.name } : { name: trimmed }, date });
    };
    return (_jsx("div", { className: "dialog", role: "presentation", children: _jsxs("form", { ref: panelRef, className: "dialog__panel", role: "dialog", "aria-modal": "true", "aria-labelledby": titleId, onSubmit: submit, onKeyDown: (event) => {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    onCancel();
                    return;
                }
                trapTab(event, panelRef.current);
            }, children: [_jsx("h2", { id: titleId, className: "dialog__title", children: labels.title }), _jsxs("label", { className: "dialog__field", children: [_jsx("span", { children: labels.person }), _jsx("input", { ref: personRef, type: "text", list: listId, autoComplete: "off", required: true, "aria-describedby": hintId, value: name, onChange: (event) => setName(event.target.value) })] }), _jsx("datalist", { id: listId, children: persons.map((person) => (_jsx("option", { value: person.name }, person.id))) }), _jsx("p", { id: hintId, className: "dialog__hint", "aria-live": "polite", children: trimmed !== '' && !match ? labels.newPerson(trimmed) : labels.personHint }), _jsxs("label", { className: "dialog__field", children: [_jsx("span", { children: labels.date }), _jsx("input", { type: "date", required: true, value: date, onChange: (event) => setDate(event.target.value) })] }), _jsxs("div", { className: "dialog__actions", children: [_jsx("button", { type: "button", onClick: onCancel, children: labels.cancel }), _jsx("button", { type: "submit", className: "dialog__primary", disabled: !canConfirm, children: labels.confirm })] })] }) }));
}
export function HighlightLimitDialog({ mode, message, current, onReplace, onAddAnyway, onCancel, labels, }) {
    const panelRef = useRef(null);
    const replaceRef = useRef(null);
    const titleId = useId();
    const messageId = useId();
    useEffect(() => replaceRef.current?.focus(), []);
    return (_jsx("div", { className: "dialog", role: "presentation", children: _jsxs("div", { ref: panelRef, className: "dialog__panel", role: "alertdialog", "aria-modal": "true", "aria-labelledby": titleId, "aria-describedby": messageId, onKeyDown: (event) => {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    onCancel();
                    return;
                }
                trapTab(event, panelRef.current);
            }, children: [_jsx("h2", { id: titleId, className: "dialog__title", children: labels.title }), _jsxs("div", { id: messageId, children: [_jsx("p", { className: "dialog__message", children: message }), current.length > 0 ? (_jsx("ul", { className: "dialog__list", children: current.map((title) => (_jsx("li", { children: title }, title))) })) : null] }), _jsxs("div", { className: "dialog__actions", children: [_jsx("button", { type: "button", onClick: onCancel, children: labels.cancel }), mode === 'warn' ? (_jsx("button", { type: "button", onClick: onAddAnyway, children: labels.addAnyway })) : null, _jsx("button", { ref: replaceRef, type: "button", className: "dialog__primary", onClick: onReplace, children: labels.replace })] })] }) }));
}
//# sourceMappingURL=TriageDialogs.js.map